
// You can write more code here

/* START OF COMPILED CODE */

import UserComponent from "./UserComponent";
import Phaser from "phaser";
/* START-USER-IMPORTS */
import Tween = Phaser.Tweens.Tween;
import Container = Phaser.GameObjects.Container;
import { Sounds } from "../../sounds";
/* END-USER-IMPORTS */

export default class CarouselComponent extends UserComponent {

  constructor(gameObject: Phaser.GameObjects.Container) {
    super(gameObject);

    this.gameObject = gameObject;
    (gameObject as any)["__CarouselComponent"] = this;

    /* START-USER-CTR-CODE */
    /* END-USER-CTR-CODE */
  }

  static getComponent(gameObject: Phaser.GameObjects.Container): CarouselComponent {
    return (gameObject as any)["__CarouselComponent"];
  }

  private gameObject: Phaser.GameObjects.Container;
  public CarouselList: (Phaser.GameObjects.Image | Phaser.GameObjects.Container)[] = [];
  public infiniteCarousel: boolean = false;
  public scrollHorizontally: boolean = true;
  public scrollVertically: boolean = false;
  public scaleRatioFromCenter: number = 0.2;
  public tweenDuration: number = 400;
  public HighlightedColour: string = "#ffffff";
  public UnhighlightedColour: string = "#ffffff";

  /* START-USER-CODE */
  public canScale:boolean = true;
  private carouselIndex:number = 0;
  private mousePrevX:number = 0;
  private mouseStartX:number = 0;
  private mousePrevY:number = 0;
  private mouseStartY:number = 0;
  private inputVel:number = 0;
  private carouselTween!:Tween;
  private isDragging:boolean = false;
  private mouseDown:boolean = false;
  private positionalDiff:number = 0;
  private prevCarouselIndex:number = 0;

  protected awake() {
    super.awake();

    this.scene.input.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.mousePrevX = this.scene.input.activePointer.x;
      this.mouseStartX = this.mousePrevX;
      this.mousePrevY = this.scene.input.activePointer.y;
      this.mouseStartY = this.mousePrevY;
      this.mouseDown = true;
    
    });
    this.scene.input.on(Phaser.Input.Events.POINTER_UP, () => {
      if(this.isDragging) {
        if(this.scrollHorizontally) {
          this.inputVel = this.mousePrevX - this.scene.input.activePointer.x;
        }
        else if(this.scrollVertically)
        {
          this.inputVel = this.mousePrevY - this.scene.input.activePointer.y;
        }
        this.snapToNearest();
        
        this.isDragging = false;
      }
      this.mouseDown = false;
    });

    if(this.scrollHorizontally)
    {
      this.positionalDiff = Math.abs(this.CarouselList[0].x - this.CarouselList[1].x);
    }
    else if(this.scrollVertically)
    {
      this.positionalDiff = Math.abs(this.CarouselList[0].y - this.CarouselList[1].y);
    }

    if(this.infiniteCarousel)
    {
      if(this.scrollHorizontally) {
        let j = 1;
        for (let i = this.CarouselList.length - 1; i > -1; --i) {
          if (this.CarouselList[i].x > (this.scene.app.ScaleConfig.sceneWidth / 2)) {
            this.CarouselList[i].x = -(this.positionalDiff * (j));
          }
          j++;
        }
      }
      else if (this.scrollVertically)
      {
        let j = 1;
        for (let i = this.CarouselList.length - 1; i > -1; --i) {
          if (this.CarouselList[i].y > (this.scene.app.ScaleConfig.sceneHeight)) {
            this.CarouselList[i].y = -(this.positionalDiff * (j));
          }
          j++;
        }
      }

    }
  }

  protected update(time: number, delta: number) {
    super.update(time, delta);
    if(this.mouseDown)
    {
      if(this.scrollHorizontally) {
        if (Math.abs(this.mouseStartX - this.scene.input.activePointer.x) > 50 && !this.isDragging) {
          this.isDragging = true;
          this.scene.events.emit("carouselMoved");
        }
        if (this.isDragging) {
          let dist = this.mousePrevX - this.scene.input.activePointer.x;
          this.gameObject.x -= dist;
          this.mousePrevX = this.scene.input.activePointer.x;
        }
      }
      else if(this.scrollVertically)
      {
        if (Math.abs(this.mouseStartY - this.scene.input.activePointer.y) > 50) {
          this.isDragging = true;
        }
        if (this.isDragging) {
          let dist = this.mousePrevY - this.scene.input.activePointer.y;
          this.gameObject.y -= dist;
          this.mousePrevY = this.scene.input.activePointer.y;
        }
      }
    }

    this.updateCarousel();
    if(this.infiniteCarousel) {
      this.updateInfiniteCarousel();
    }
  }

  protected updateInfiniteCarousel()
  {
    if(this.scrollHorizontally) {
      let j = 1;
      let l = this.CarouselList.length;
      for (let i = this.CarouselList.length - 1; i > -1; --i) {
        let x = (this.gameObject.x - (this.scene.app.ScaleConfig.sceneWidth / 2)) + this.CarouselList[i].x;
        if (x > (this.scene.app.ScaleConfig.sceneWidth / 2)+this.CarouselList[i].getBounds().width/2) {
          this.CarouselList[i].x -= (this.positionalDiff * (l));
        }
        if (x < -(this.scene.app.ScaleConfig.sceneWidth / 2)-this.CarouselList[i].getBounds().width/2) {
          this.CarouselList[i].x += (this.positionalDiff * (l));
        }
        j++;
      }
    }
    else if(this.scrollVertically)
    {
      let j = 1;
      let l = this.CarouselList.length;
      for (let i = this.CarouselList.length - 1; i > -1; --i) {
        let y = (this.gameObject.y - (this.scene.app.ScaleConfig.sceneHeight / 2)) + this.CarouselList[i].y;
        if (y > (this.scene.app.ScaleConfig.sceneHeight)) {
          this.CarouselList[i].y -= (this.positionalDiff * (l));
        }
        if (y < -(this.scene.app.ScaleConfig.sceneHeight)) {
          this.CarouselList[i].y += (this.positionalDiff * (l));
        }
        j++;
      }
    }
  }

  public moveCarouselLeft()
  {
    this.scene.events.emit("carouselMoved");
    if(this.infiniteCarousel) {
      let dist = 100000;
      let index = -1;

      if(this.scrollHorizontally) {
        for (let i = 0; i < this.CarouselList.length; ++i) {
          let d = Math.abs(((this.gameObject.x) + this.CarouselList[i].x + this.positionalDiff) - this.scene.app.ScaleConfig.sceneWidth / 2);
          if (d < dist) {
            dist = d;
            index = i;
          }
        }
      }
      else if(this.scrollVertically)
      {
        for (let i = 0; i < this.CarouselList.length; ++i) {
          let d = Math.abs(((this.gameObject.y) + this.CarouselList[i].y + this.positionalDiff) - this.scene.app.ScaleConfig.sceneHeight / 2);
          if (d < dist) {
            dist = d;
            index = i;
          }
        }
      }

      this.carouselIndex = index;
      this.moveToIndex(this.carouselIndex);
    }
    else
    {
      if(this.carouselIndex > 0)
      {
        this.carouselIndex--;
        this.moveToIndex(this.carouselIndex);
      }
    }
  }

  public moveCarouselRight() {
    this.scene.events.emit("carouselMoved");
    if (this.infiniteCarousel) {
      let dist = 100000;
      let index = -1;

      if(this.scrollHorizontally) {
        for (let i = 0; i < this.CarouselList.length; ++i) {
          let d = Math.abs(((this.gameObject.x) + this.CarouselList[i].x - this.positionalDiff) - this.scene.app.ScaleConfig.sceneWidth / 2);
          if (d < dist) {
            dist = d;
            index = i;
          }
        }
      }else if(this.scrollVertically)
      {
        for (let i = 0; i < this.CarouselList.length; ++i) {
          let d = Math.abs(((this.gameObject.y) + this.CarouselList[i].y - this.positionalDiff) - this.scene.app.ScaleConfig.sceneHeight / 2);
          if (d < dist) {
            dist = d;
            index = i;
          }
        }
      }

      this.carouselIndex = index;
      this.moveToIndex(this.carouselIndex);
    }
    else
    {
      if(this.carouselIndex < this.CarouselList.length-1)
      {
        this.carouselIndex++;
        this.moveToIndex(this.carouselIndex);
      }
    }
  }

  stopTween()
  {
    if(this.carouselTween !== null && this.carouselTween !== undefined)
    {
      this.carouselTween.stop();
    }
  }

  public moveToIndex(index:number, animate:boolean = true)
  {
    

    this.carouselIndex = index;
    this.stopTween();
    if(this.scrollHorizontally) {
      if (animate) {
        this.carouselTween = this.scene.tweens.add({
          targets: this.gameObject,
          props: {
            x: {value: (this.scene.app.ScaleConfig.sceneWidth / 2) - this.CarouselList[index].x, duration: this.tweenDuration},
          },
          ease: 'Quad.InOut',
          onComplete:()=>{
            this.scene.events.emit("carouselLanded",this.CarouselList[index]);
          }
        });
      } else {
        this.gameObject.x = (this.scene.app.ScaleConfig.sceneWidth / 2) - this.CarouselList[index].x;
      }
    }
    else if(this.scrollVertically)
    {
      if (animate) {
        this.carouselTween = this.scene.tweens.add({
          targets: this.gameObject,
          props: {
            y: {value: (this.scene.app.ScaleConfig.sceneHeight / 2) - this.CarouselList[index].y, duration: this.tweenDuration},
          },
          ease: 'Quad.InOut'
        });
      } else {
        this.gameObject.y = (this.scene.app.ScaleConfig.sceneHeight / 2) - this.CarouselList[index].y;
      }
    }
  }

  public spinToIndex(index:number, animate:boolean = true)
  {
    let offset = (this.CarouselList.length+index)* this.positionalDiff;

    this.carouselIndex = index;
    this.stopTween();
    if(this.scrollHorizontally) {
      if (animate) {
        this.carouselTween = this.scene.tweens.add({
          targets: this.gameObject,
          props: {
            x: {value:(this.scene.app.ScaleConfig.sceneWidth / 2) - (offset), duration: this.tweenDuration*2},
          },
          ease: 'Quad.InOut',
          onComplete:()=>{
            this.scene.events.emit("carouselLanded",this.CarouselList[index]);
          }
        });
      } else {
        this.gameObject.x = (this.scene.app.ScaleConfig.sceneWidth / 2) - this.CarouselList[index].x;
      }
    }
    else if(this.scrollVertically)
    {
      if (animate) {
        this.carouselTween = this.scene.tweens.add({
          targets: this.gameObject,
          props: {
            y: {value: (this.scene.app.ScaleConfig.sceneHeight / 2) - this.CarouselList[index].y, duration: this.tweenDuration},
          },
          ease: 'Quad.InOut'
        });
      } else {
        this.gameObject.y = (this.scene.app.ScaleConfig.sceneHeight / 2) - this.CarouselList[index].y;
      }
    }
  }

  snapToNearest()
  {
    let dist = 100000;
    let index = -1;
    for(let i = 0; i < this.CarouselList.length; ++i)
    {
      if(this.scrollHorizontally) {
        let d = Math.abs(((this.gameObject.x - (this.inputVel * 10)) + this.CarouselList[i].x) - this.scene.app.ScaleConfig.sceneWidth / 2);
        if (d < dist) {
          dist = d;
          index = i;
        }
      }
      else if(this.scrollVertically)
      {
        let d = Math.abs(((this.gameObject.y - (this.inputVel * 10)) + this.CarouselList[i].y) - this.scene.app.ScaleConfig.sceneHeight / 2);
        if (d < dist) {
          dist = d;
          index = i;
        }
      }
    }

    this.carouselIndex = index;

    if(this.scrollHorizontally) {
      this.carouselTween = this.scene.tweens.add({
        targets: this.gameObject,
        props: {
          x: {value: (this.scene.app.ScaleConfig.sceneWidth / 2) - this.CarouselList[index].x, duration: this.tweenDuration},
        },
        ease: 'Quad.Out',
        onComplete:()=>{
          this.scene.events.emit("carouselLanded",this.CarouselList[index]);
        }
      });
    }
    else if(this.scrollVertically)
    {
      this.carouselTween = this.scene.tweens.add({
        targets: this.gameObject,
        props: {
          y: {value: (this.scene.app.ScaleConfig.sceneHeight / 2) - this.CarouselList[index].y, duration: this.tweenDuration},
        },
        ease: 'Quad.Out'
      });
    }
  }

  updateCarousel()
  {
    

    if(this.canScale)
    {
      let d:number = 1000;
      let index:number = 0;
      for(let i = 0; i < this.CarouselList.length; ++i)
      {
        if(this.scrollHorizontally) {
          let dist = Math.abs(this.gameObject.x + this.CarouselList[i].x - (this.scene.app.ScaleConfig.sceneWidth / 2));
          if(dist < d)
          {
            d = dist;
            index = i;
          }
          let scale = (dist/this.positionalDiff)*this.scaleRatioFromCenter;

          this.CarouselList[i].scale = 1 - Math.min(1,Math.max(0,scale));
          this.CarouselList[i].y = -dist/5;

          let children = (this.CarouselList[i] as Container).getAll();
          for(let i = 0; i < children.length; ++i)
          {          
            (children[i] as Phaser.GameObjects.Image).tint = this.lerpColor('#ffffff','031f1c',Math.min(1,Math.max(0,scale*4)));
           
          }
        }
        else if(this.scrollVertically)
        {
          let dist = Math.abs(this.gameObject.y + this.CarouselList[i].y - (this.scene.app.ScaleConfig.sceneHeight / 2));
          dist = (dist/this.positionalDiff)*this.scaleRatioFromCenter;
          this.CarouselList[i].scale = 1 - dist;
        }
      }

      if(index != this.prevCarouselIndex)
      {
        this.scene.app.AudioHandler.playSound(this.scene, Sounds.Track.Swish1, Sounds.Channel.SFX, { volume: 0.3 });
        this.prevCarouselIndex = index;
      }
    }
  }

  lerpColor(a:any, b:any, amount:number) { 

    var ah = parseInt(a.replace(/#/g, ''), 16),
        ar = ah >> 16, ag = ah >> 8 & 0xff, ab = ah & 0xff,
        bh = parseInt(b.replace(/#/g, ''), 16),
        br = bh >> 16, bg = bh >> 8 & 0xff, bb = bh & 0xff,
        rr = ar + amount * (br - ar),
        rg = ag + amount * (bg - ag),
        rb = ab + amount * (bb - ab);

    return ((1 << 24) + (rr << 16) + (rg << 8) + rb | 0);
}

  public get CurrentIndex()
  {
    return this.carouselIndex;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
